<div class="widget-group" fxLayout="column" fxFlex="100" *fuseIfOnDom >

    <p [class]="{'print': printable}">{{dataSource.descripcion}}</p>

    <mat-tree [dataSource]="dataSourceTree" [treeControl]="treeControl" >
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding fxLayout="row wrap"  [class]="{'print': printable}">
        <!-- use a disabled button to provide padding for tree leaf -->

        <div fxLayout="row" fxFlex="100">
          <button mat-icon-button disabled></button>
          <div class="informacion" fxFlex="60" >
            <span style="font-weight: bold;margin-right:5px;">{{node.name}}</span>
            <span *ngIf="node.descripcion!=null && node.descripcion!=''" style="margin-right:5px;"> |
            <span [innerHTML]="formatDescription(node.descripcion)"></span>
            </span>
            <!-- <mat-icon  aria-hidden="false" aria-label="print" *ngIf="node.expandable">print</mat-icon> -->
            
            <mat-icon  aria-hidden="false" aria-label="statistics" *ngIf="node.expandable" (click)="viewStatistics(node,1,false)">bar_chart</mat-icon>
            <!-- <mat-icon  aria-hidden="false" aria-label="statistics" *ngIf="node.expandable && node.sentencias!=null" (click)="viewStatistics(node,0,true)">insert_chart_outlined</mat-icon> -->
          </div>
          <div class="respuestas" fxFlex="40" *ngIf="!node.expandable" >
            <sentencia-resultado-table [esMultiple]="es_multiple" 
                                      [tablaDeAnalisisDeBrechas]="tablaDeAnalisisDeBrechas" 
                                      [analisisDeBrechasEstado]="analisisDeBrechasEstado"
                                      [isResponsable]="isResponsable" 
                                      [sentencia]="node"
                                      (loadData)="reloadData()"></sentencia-resultado-table>
            
          </div>

        </div>
        
        
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding  [class]="{'print': printable}">
        
        <div class="informacion" >
          <button mat-icon-button matTreeNodeToggle
                [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <span style="font-weight: bold;margin-right:5px;">{{node.name}}</span>
          <span *ngIf="node.descripcion!=null && node.descripcion!=''" style="margin-right:5px;"> | {{node.descripcion}}</span>
          <!-- <mat-icon  aria-hidden="false" aria-label="print" *ngIf="node.expandable">print</mat-icon> -->
          
          <mat-icon  aria-hidden="false" aria-label="statistics" *ngIf="node.expandable" (click)="viewStatistics(node,1,false)">bar_chart</mat-icon>
          <!-- <mat-icon  aria-hidden="false" aria-label="statistics" *ngIf="node.expandable && node.sentencias!=null" (click)="viewStatistics(node,0,true)">insert_chart_outlined</mat-icon> -->
          
        </div>

        <div class="respuestas" *ngIf="!node.expandable" >
          <sentencia-resultado-table [esMultiple]="es_multiple" 
                                    [tablaDeAnalisisDeBrechas]="tablaDeAnalisisDeBrechas" 
                                    [isResponsable]="isResponsable" 
                                    [sentencia]="node"
                                    (loadData)="reloadData()" ></sentencia-resultado-table>
        </div>
      
      </mat-tree-node>
    </mat-tree>

</div>